import { z } from 'zod';
import { languages, type Language } from './enums.js';

/**
 * Nom d'une copie de questionnaire. Le suffixe suit la langue de l'interface au moment
 * de la duplication et fait partie du nom stocké : ce n'est pas un libellé d'écran.
 * La longueur max est celle du schéma de création, pour qu'une copie reste modifiable.
 */
export const QUESTIONNAIRE_TEMPLATE_NAME_MAX = 120;

const COPY_SUFFIX: Record<Language, string> = {
  fr: '(copie)',
  de: '(Kopie)',
  en: '(copy)',
};

export function questionnaireCopyName(name: string, language: Language): string {
  const tail = ` ${COPY_SUFFIX[language]}`;
  const max = QUESTIONNAIRE_TEMPLATE_NAME_MAX;
  if (name.length + tail.length <= max) return `${name}${tail}`;
  const head = name.slice(0, Math.max(0, max - tail.length)).trimEnd();
  if (head.length === 0) return tail.trim().slice(0, max);
  return `${head}${tail}`;
}

export const questionnaireTemplateDuplicateSchema = z
  .object({ language: z.enum(languages) })
  .strict();
export type QuestionnaireTemplateDuplicateInput = z.infer<
  typeof questionnaireTemplateDuplicateSchema
>;
